import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { UtilsService } from './utils.service';


@Injectable({
  providedIn: 'root'
})
export class LoadCalculatorService {

  constructor(public http: HttpClient, public utils: UtilsService) { }

  getLoadCategories(guidId: string) {
    return this.http.get(`${this.utils.apiUrl}LoadCalculator/GetLoadCalculatorProducts?categoryGuidId=${guidId}`)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  submitLoadValues(formValues: object) {
    return this.http.post(`${this.utils.apiUrl}LoadCalculator/LoadCalculator`, formValues)
      .pipe(catchError(this.utils.processError.bind(this)))
  }



  getRecommendedProducts(values: any) {
    return this.http.post(`${this.utils.apiUrl}LoadCalculator/RecommneddedProducts`, values)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  getSolarRecommendedProducts(values: any) {
    return this.http.post(`${this.utils.apiUrl}LoadCalculator/SolarRecommneddedProducts`, values)
      .pipe(catchError(this.utils.processError.bind(this)))
  }


}
